import { TimezoneShortEnum } from '@enums/timezone/timezone-short.enum';
import { TimezoneInterface } from '@interfaces/timezone/timezone.interface';
import { TimezoneEnum } from '@enums/timezone/timezone.enum';

export const timezones: ReadonlyMap<TimezoneShortEnum, TimezoneInterface> = new Map<TimezoneShortEnum, TimezoneInterface>([
  [
    TimezoneShortEnum.AKDT,
    {
      timezoneName: TimezoneEnum.AKDT,
      shortName: TimezoneShortEnum.AKDT,
      offset: -480,
      utcOffset: -8,
      title: `${TimezoneShortEnum.AKDT}(UTC -8)`,
      localTime: 'US/Alaska',
      gmt: 'GMT-0800',
    },
  ],
  [
    TimezoneShortEnum.AKST,
    {
      timezoneName: TimezoneEnum.AKST,
      shortName: TimezoneShortEnum.AKST,
      offset: -540,
      utcOffset: -9,
      title: `${TimezoneShortEnum.AKST}(UTC -9)`,
      localTime: 'America/Adak',
      gmt: 'GMT-0900',
    },
  ],
  [
    TimezoneShortEnum.AST,
    {
      timezoneName: TimezoneEnum.AST,
      shortName: TimezoneShortEnum.AST,
      offset: -240,
      utcOffset: -4,
      title: `${TimezoneShortEnum.AST}(UTC -4)`,
      localTime: 'America/Caracas',
      gmt: 'GMT-0400',
    },
  ],
  [
    TimezoneShortEnum.CST,
    {
      timezoneName: TimezoneEnum.CST,
      shortName: TimezoneShortEnum.CST,
      offset: -360,
      utcOffset: -6,
      title: `${TimezoneShortEnum.CST}(UTC -6)`,
      localTime: 'America/Managua',
      gmt: 'GMT-0600',
    },
  ],
  [
    TimezoneShortEnum.CDT,
    {
      timezoneName: TimezoneEnum.CDT,
      shortName: TimezoneShortEnum.CDT,
      offset: -300,
      utcOffset: -5,
      title: `${TimezoneShortEnum.CDT}(UTC -5)`,
      localTime: 'America/Bogota',
      gmt: 'GMT-0500',
    },
  ],
  [
    TimezoneShortEnum.EDT,
    {
      timezoneName: TimezoneEnum.EDT,
      shortName: TimezoneShortEnum.EDT,
      offset: -240,
      utcOffset: -4,
      title: `${TimezoneShortEnum.EDT}(UTC -4)`,
      localTime: 'America/Caracas',
      gmt: 'GMT-0400',
    },
  ],
  [
    TimezoneShortEnum.EST,
    {
      timezoneName: TimezoneEnum.EST,
      shortName: TimezoneShortEnum.EST,
      offset: -300,
      utcOffset: -5,
      title: `${TimezoneShortEnum.EST}(UTC -5)`,
      localTime: 'America/Bogota',
      gmt: 'GMT-0500',
    },
  ],
  [
    TimezoneShortEnum.HDT,
    {
      timezoneName: TimezoneEnum.HDT,
      shortName: TimezoneShortEnum.HDT,
      offset: -540,
      utcOffset: -9,
      title: `${TimezoneShortEnum.HDT}(UTC -9)`,
      localTime: 'America/Adak',
      gmt: 'GMT-0900',
    },
  ],
  [
    TimezoneShortEnum.HST,
    {
      timezoneName: TimezoneEnum.HST,
      shortName: TimezoneShortEnum.HST,
      offset: -600,
      utcOffset: -10,
      title: `${TimezoneShortEnum.HST}(UTC -10)`,
      localTime: '',
      gmt: 'GMT-1000',
    },
  ],
  [
    TimezoneShortEnum.MDT,
    {
      timezoneName: TimezoneEnum.MDT,
      shortName: TimezoneShortEnum.MDT,
      offset: -360,
      utcOffset: -6,
      title: `${TimezoneShortEnum.MDT}(UTC -6)`,
      localTime: 'America/Managua',
      gmt: 'GMT-0600',
    },
  ],
  [
    TimezoneShortEnum.MST,
    {
      timezoneName: TimezoneEnum.MST,
      shortName: TimezoneShortEnum.MST,
      offset: -420,
      utcOffset: -7,
      title: `${TimezoneShortEnum.MST}(UTC -7)`,
      localTime: 'America/Los_Angeles',
      gmt: 'GMT-0700',
    },
  ],
  [
    TimezoneShortEnum.PDT,
    {
      timezoneName: TimezoneEnum.PDT,
      shortName: TimezoneShortEnum.PDT,
      offset: -420,
      utcOffset: -7,
      title: `${TimezoneShortEnum.PDT}(UTC -7)`,
      localTime: 'America/Los_Angeles',
      gmt: 'GMT-0700',
    },
  ],
  [
    TimezoneShortEnum.PST,
    {
      timezoneName: TimezoneEnum.PST,
      shortName: TimezoneShortEnum.PST,
      offset: -480,
      utcOffset: -8,
      title: `${TimezoneShortEnum.PST}(UTC -8)`,
      localTime: 'US/Alaska',
      gmt: 'GMT-0800',
    },
  ],
]);

export const DEFAULT_TIMEZONE = timezones.get(TimezoneShortEnum.MST);
export const DEFAULT_TIMEZONE_OFFSET = DEFAULT_TIMEZONE.offset;
export const DEFAULT_TIMEZONE_SHORTNAME = DEFAULT_TIMEZONE.shortName;
